export const searchActionTypes = {
	CHANGE_SEARCH_INPUT_VALUE: 'CHANGE_SEARCH_INPUT_VALUE',
	CLEAR_SEARCH_INPUT_VALUE: 'CLEAR_SEARCH_INPUT_VALUE',
	FETCH_SEARCH_RESULTS_REQUEST: 'FETCH_SEARCH_RESULTS_REQUEST',
	FETCH_SEARCH_RESULTS_SUCCESS: 'FETCH_SEARCH_RESULTS_SUCCESS',
	FETCH_SEARCH_RESULTS_FAILURE: 'FETCH_SEARCH_RESULTS_FAILURE',
}